export const actionCreator = (type, payload) => ({type, payload});
